import { SelectItem } from 'app/components/SelectList';
import { ModuleType } from 'types/domain/module';

export const ModuleTypes: SelectItem[] = [
  { name: 'Standard', value: ModuleType.STANDARD },
  { name: 'Powerpoint', value: ModuleType.PPT },
  { name: 'PDF', value: ModuleType.PDF },
  { name: 'Text', value: ModuleType.TEXT },
  { name: 'YouTube', value: ModuleType.YOUTUBE },
  { name: 'Website', value: ModuleType.WEBSITE },
  { name: 'SCORM', value: ModuleType.SCORM },
  { name: 'VR', value: ModuleType.VR },
  { name: 'AR', value: ModuleType.AR },
];
